import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "toast-success",
  class: "flex items-center w-full max-w-xs p-4 mb-4 text-white bg-accent-600 rounded-lg shadow-card fixed top-20 right-4 z-[60]",
  role: "alert"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 mr-2",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M5 13l4 4L19 7"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium" }, "Post created successfully!", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "bg-white rounded-xl border border-primary-200 shadow-soft overflow-hidden" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-heading font-semibold text-primary-800" }, " Share with your neighbors ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "p-6 space-y-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "sr-only",
  for: "post-title"
}, "Title", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "sr-only",
  for: "post-message"
}, "Message", -1)
const _hoisted_14 = {
  key: 0,
  class: "w-full text-red-600 text-sm"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-primary-700 mb-2" }, " Images (up to 5) ", -1)
const _hoisted_16 = {
  key: 0,
  class: "mt-3 grid grid-cols-3 gap-2"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-3 h-3",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "flex items-center justify-end gap-3 p-4 border-t border-primary-100 bg-primary-50" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Posting... ")
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Post ")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4 ml-2",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M14 5l7 7m0 0l-7 7m7-7H3"
  })
], -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]

import { usePostStore } from "@/stores/posts";
import TypeSelectComponent from "@/components/posts/TypeSelectComponent.vue";
import { ref } from "vue";

type PostType =
  | "service_to_offer"
  | "looking_to_borrow"
  | "for_sale"
  | "free"
  | "question"
  | "social"
  | "general";


export default /*#__PURE__*/_defineComponent({
  emits: ["close", "post-created"],
  setup(__props, { emit }: { emit: ({
  (e: "close"): void;
  (e: "post-created"): void;
}), expose: any, slots: any, attrs: any }) {



const post = usePostStore();

const title = ref("");
const description = ref("");
const images = ref<File[]>([]);
const imagePreviews = ref<string[]>([]);
const type = ref("");
const error = ref("");
const toastVisible = ref(false);
const isSubmitting = ref(false);

const handleChoice = (choice: PostType) => {
  type.value = choice;
};

const handleClose = () => {
  resetForm();
  emit("close");
};

const resetForm = () => {
  title.value = "";
  description.value = "";
  type.value = "";
  images.value = [];
  imagePreviews.value = [];
  error.value = "";
  // Reset the file input
  const fileInput = document.getElementById("post-images") as HTMLInputElement;
  if (fileInput) fileInput.value = "";
};

const handleImageUpload = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.files) {
    const newFiles = Array.from(target.files).slice(0, 5 - images.value.length);

    for (const file of newFiles) {
      if (images.value.length >= 5) break;
      images.value.push(file);

      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        imagePreviews.value.push(e.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  }
};

const removeImage = (index: number) => {
  images.value.splice(index, 1);
  imagePreviews.value.splice(index, 1);
};

const makePost = async () => {
  error.value = "";

  if (title.value !== "" && description.value !== "" && type.value !== "") {
    isSubmitting.value = true;

    try {
      const newPost: NewPost = {
        title: title.value,
        description: description.value,
        type: type.value,
        image: images.value.length > 0 ? images.value[0] : undefined,
        images: images.value.length > 1 ? images.value.slice(1) : undefined,
      };

      await post.make_post(newPost);

      toastVisible.value = true;
      setTimeout(() => {
        toastVisible.value = false;
      }, 2500);

      resetForm();
      emit("post-created");
    } catch (err) {
      console.error("Failed to create post:", err);
      error.value = "Failed to create post. Please try again.";
    } finally {
      isSubmitting.value = false;
    }
  } else {
    if (title.value === "") error.value += "You must set the title. ";
    if (description.value === "")
      error.value += "You must add some text to the post. ";
    if (type.value === "") error.value += "You must select a post type.";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (toastVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("button", {
            type: "button",
            class: "ml-auto -mx-1.5 -my-1.5 text-white/80 hover:text-white rounded-lg p-1.5 hover:bg-accent-700 inline-flex h-8 w-8 transition-colors",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (toastVisible.value = false))
          }, _hoisted_6)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", { class: "flex items-center justify-between p-4 border-b border-primary-100" }, [
        _hoisted_8,
        _createElementVNode("button", {
          onClick: handleClose,
          class: "p-2 text-primary-400 hover:text-primary-600 hover:bg-primary-100 rounded-lg transition-colors",
          "aria-label": "Close"
        }, _hoisted_10)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(TypeSelectComponent, { onChoice_made: handleChoice }),
        _createElementVNode("div", null, [
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            id: "post-title",
            class: "w-full p-3 text-sm border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors",
            placeholder: "Title",
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((title).value = $event))
          }, null, 512), [
            [_vModelText, title.value]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_13,
          _withDirectives(_createElementVNode("textarea", {
            id: "post-message",
            class: "w-full p-3 text-sm border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors",
            placeholder: "What's on your mind?",
            rows: "4",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((description).value = $event))
          }, null, 512), [
            [_vModelText, description.value]
          ]),
          (error.value !== '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(error.value), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _hoisted_15,
          _createElementVNode("input", {
            id: "post-images",
            type: "file",
            multiple: "",
            class: "w-full p-3 text-sm border border-primary-200 rounded-lg file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-primary-100 file:text-primary-700 hover:file:bg-primary-200 transition-colors",
            accept: "image/*",
            onChange: handleImageUpload
          }, null, 32),
          (imagePreviews.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imagePreviews.value, (preview, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "relative group"
                  }, [
                    _createElementVNode("img", {
                      src: preview,
                      class: "w-full h-24 object-cover rounded-lg",
                      alt: "Preview"
                    }, null, 8, _hoisted_17),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: ($event: any) => (removeImage(index)),
                      class: "absolute top-1 right-1 p-1 bg-red-500 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                    }, _hoisted_20, 8, _hoisted_18)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("button", {
          onClick: handleClose,
          class: "px-4 py-2 text-sm font-medium text-primary-600 hover:text-primary-800 hover:bg-primary-100 rounded-lg transition-colors"
        }, " Cancel "),
        _createElementVNode("button", {
          onClick: makePost,
          disabled: isSubmitting.value,
          class: "inline-flex items-center justify-center px-6 py-2 text-white bg-accent-600 rounded-lg hover:bg-accent-700 transition-colors focus:outline-none focus:ring-2 focus:ring-accent-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
        }, [
          (isSubmitting.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _hoisted_26))
            : (_openBlock(), _createElementBlock("span", _hoisted_27, _hoisted_30))
        ], 8, _hoisted_22)
      ])
    ])
  ], 64))
}
}

})